import type { TRemotePicture } from '~/types/media.types'

export type TJewelryItem = {
  attributesBottom: string[]
  attributesTop: string[]
  canBuy: boolean
  category: string
  code: string
  collection: string
  hasPriceFromPrefix: boolean
  id: number
  insertsWeight: TNullable<number>
  isOffer: boolean
  isPriceHidden: boolean
  name: string
  picture: TRemotePicture
  pictures: TRemotePicture[]
  price: number
  skuId: number
  type: 'jewelry'
  url: string
}

export type TDiamondItem = {
  clarity: TNullable<string>
  clarityRu: TNullable<string>
  code: string
  color: TNullable<string>
  colorRu: TNullable<string>
  id: number
  isAvailable: boolean
  isPriceHidden: boolean
  name: string
  picture: string
  pictures: string[]
  price: number
  shape: string
  type: 'diamond'
  url: string
  weight: TNullable<string>
}

export type TProductItem =
  | TDiamondItem
  | (TJewelryItem & {
      type: 'jewelry' | 'diamond'
    })

export type TCatalogGridLayout = 'one' | 'two'

export enum TFilterItemType {
  Category,
  Multiselect,
  Range,
  MultiselectGrouped,
}

export type TFilterItem = (
  | TFilterItemCategory
  | TFilterItemMultiselect
  | TFilterItemRange
  | TFilterItemGroupedMultiselect
) & {
  applyingOrder: number
  code: string
  disabled: boolean
  isOpened: boolean
  showInvestmentDiamonds: boolean
  showParametersRussianMetricSystem: boolean
  title: string
  tooltip: TNullable<string>
  type: TFilterItemType
}

export type TFilterItemCategory = {
  items: {
    code: TNullable<string>
    disabled: boolean
    name: string
  }[]
}

export type TFilterItemMultiselect = {
  items: {
    code: string
    disabled: boolean
    isRuValue: boolean
    name: string
  }[]
}

export type TFilterItemRange = {
  range: {
    // from: string
    // to: string
    from: number
    to: number
  }
}

export type TFilterItemGroupedMultiselect = {
  groups: {
    items: {
      code: string
      disabled: boolean
      isRuValue: boolean
      name: string
    }[]
    name: TNullable<string>
  }[]
}

export type TSortItem = {
  code: string
  direction: 'asc' | 'desc'
  name: string
  nameRu: TNullable<string>
}

export type TCatalogNavigation = {
  isLastPage: boolean
  lastPage: number
  page: number
  perPage: number
  total: number
}
